import { objectWithoutKeys, updateRecord } from '@ms/yammer-data-support';

import { Publishers } from '../types';

import { PublishersAction } from './reducer.types';
import { Publisher } from './types';

const removePublisher = (state: Publishers, publisherId: Publisher['id']) => objectWithoutKeys(state, [publisherId]);

const collapsePublisher = (state: Publishers, publisherId: Publisher['id']): Publishers =>
  updateRecord(state, publisherId, { isExpanded: false });

const expandPublisher = (state: Publishers, publisherId: Publisher['id']): Publishers =>
  updateRecord(state, publisherId, { isExpanded: true });

type CloseActionsReducer = (state: Publishers, action: PublishersAction) => Publishers;
export const closeActionsReducer: CloseActionsReducer = (state, action) => {
  switch (action.type) {
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_PENDING':
      return updateRecord(state, action.payload.publisherId, {
        wasPublishedAsDraft: action.payload.isDraft,
      });
    case 'PUBLISHER.PUBLISH_PRAISE_MESSAGE_PENDING':
      return updateRecord(state, action.payload.publisherId, {
        wasPublishedAsDraft: action.payload.isDraft,
      });
    case 'PUBLISHER.PUBLISH_POLL_MESSAGE_PENDING':
      return updateRecord(state, action.payload.publisherId, {
        wasPublishedAsDraft: action.payload.isDraft,
      });
    case 'PUBLISHER.REMOVE':
      return removePublisher(state, action.payload.id);
    case 'PUBLISHER.PUBLISH_EVENT_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_USER_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_USER_MOMENT_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_USER_POLL_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_USER_PRAISE_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_DIRECT_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_EDIT_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_POLL_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_PRAISE_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_REPLY_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_TEAMS_MEETING_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.PUBLISH_NETWORK_QUESTION_MESSAGE_FULFILLED':
      return removePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.COLLAPSE':
      return collapsePublisher(state, action.payload.publisherId);
    case 'PUBLISHER.EXPAND':
      return expandPublisher(state, action.payload.publisherId);
    default:
      return state;
  }
};
